<template>
  <!--
    Mirrors InstitutionCard's box exactly — same padding, same 40px logo plate,
    same two text lines — so the grid does not reflow when results replace it.
  -->
  <div
    class="flex flex-col gap-2.5 min-w-0 p-3.5 pb-3
      bg-card border border-border rounded-ds-md"
    aria-hidden="true"
  >
    <div class="flex items-start justify-between">
      <DSSkeleton class="size-10 shrink-0 rounded-ds-sm" />
      <DSSkeleton class="size-4 rounded-ds-sm" />
    </div>
    <div class="min-w-0">
      <DSSkeleton class="h-5 w-3/4 rounded-ds-sm" />
      <DSSkeleton class="h-4 w-1/2 mt-0.5 rounded-ds-sm" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { DSSkeleton } from '@ds'
</script>
